export default __webpack_public_path__ + "static/media/4B0D38A3-791F-4EB8-A629-2A9E55726EAA_1_105_c.580442b9.jpeg";